(() => {
  const banner = document.querySelector('[data-cz-cookie-banner]');
  const dialog = document.getElementById('CzPrivacyDialog');
  const guarantee = document.getElementById('CzGuaranteeDialog');
  if (!banner || !dialog || !guarantee) return;
  const purposes = ['preferences', 'analytics', 'marketing', 'sale_of_data'];
  const version = 'cz-2026-10-01.1';
  const maxAge = 15552000;
  let api, busy = false, retryTimer, lastFocus, attempts = 0, consentTimer, pendingSince, dismissed = false;
  const dismissalKey = 'cz_privacy_dismiss_until';
  const dismissalUntil = () => {
    try { return Number(document.cookie.split('; ').find(c => c.startsWith(dismissalKey + '='))?.split('=')[1]) || 0; } catch { return 0; }
  };
  const dismissalValid = () => {
    const until = dismissalUntil();
    return until > Date.now() && until <= Date.now() + 86400000;
  };
  dismissed = dismissalValid();
  const receipt = () => {
    try { return JSON.parse(decodeURIComponent(document.cookie.split('; ').find(c => c.startsWith('cz_privacy_choice='))?.split('=').slice(1).join('=') || 'null')); } catch { return null; }
  };
  const setBanner = visible => {banner.hidden = !visible;if (visible) banner.style.removeProperty('display');else banner.style.setProperty('display', 'none', 'important');document.body.classList.toggle('cz-cookie-banner-open', visible);};
  const showError = show => document.querySelectorAll('[data-cz-cookie-error]').forEach(e => {
    e.hidden = !show;
    if (show && !e.querySelector('[data-cz-dismiss-error]')) {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.czDismissError = '';
      button.textContent = dialog.querySelector('[data-cz-dialog-close]')?.getAttribute('aria-label') || '×';
      e.append(' ', button);
    }
  });
  const matchesChoices = (consent, choices) => purposes.every(p => {
    if (consent[p] === (choices[p] ? 'yes' : 'no')) return true;
    return p === 'sale_of_data' && consent[p] !== 'yes' && api?.saleOfDataAllowed?.() === false;
  });
  const syncGoogle = consent => {
    const analytics = consent.analytics === 'yes' && api?.analyticsProcessingAllowed?.() !== false;
    const marketing = consent.marketing === 'yes' && api?.marketingAllowed?.() !== false;
    const sharing = consent.sale_of_data === 'yes' && api?.saleOfDataAllowed?.() !== false && window.navigator?.globalPrivacyControl !== true;
    window.gtag?.('consent', 'update', {analytics_storage:analytics ? 'granted' : 'denied',ad_storage:marketing ? 'granted' : 'denied',ad_user_data:marketing && sharing ? 'granted' : 'denied',ad_personalization:marketing && sharing ? 'granted' : 'denied'});
  };
  const sync = () => {
    if (!api || busy) return;
    const consent = api.currentVisitorConsent();
    purposes.forEach(p => dialog.querySelector(`[data-cz-purpose="${p}"]`).checked = consent[p] === 'yes');
    document.querySelector('[data-cz-consent-receipt]').textContent = api.consentId?.() || '—';
    syncGoogle(dismissed ? Object.fromEntries(purposes.map(p => [p, 'no'])) : consent);
    const saved = receipt();
    const validReceipt = !!saved?.choices && saved.version === version && Number.isFinite(saved.at) && saved.at <= Date.now() && Date.now() - saved.at < maxAge * 1000 && purposes.every(p => typeof saved.choices[p] === 'boolean');
    const matches = validReceipt && matchesChoices(consent, saved.choices);
    clearTimeout(consentTimer);
    if (validReceipt && !matches) {
      pendingSince ??= Date.now();
      if (Date.now() - pendingSince < 2000) {
        setBanner(false);
        consentTimer = setTimeout(sync, 100);
        return;
      }
    } else pendingSince = undefined;
    setBanner(!matches && !dismissed);
    showError(false);
  };
  const setBusy = state => {
    busy = state;
    document.querySelectorAll('[data-cz-consent]').forEach(b => b.disabled = state);
  };
  const openSettings = () => {
    dismissed = false;
    try { document.cookie = `${dismissalKey}=; Max-Age=0; Path=/; SameSite=Lax; Secure`; } catch {}
    if (api) {
      const consent = api.currentVisitorConsent();
      purposes.forEach(p => dialog.querySelector(`[data-cz-purpose="${p}"]`).checked = consent[p] === 'yes');
    }
    lastFocus = document.activeElement;
    if (!dialog.open) dialog.showModal();
    if (!api) loadApi();
  };
  const close = target => {
    target.close();
    if (lastFocus?.isConnected) lastFocus.focus({preventScroll:true});
  };
  const save = action => {
    if (busy) return;
    if (!api) { showError(true); loadApi(); return; }
    const choices = Object.fromEntries(purposes.map(p => [p, action === 'save' ? dialog.querySelector(`[data-cz-purpose="${p}"]`).checked : action === 'accept']));
    if (window.navigator?.globalPrivacyControl === true) choices.sale_of_data = false;
    const previous = api.currentVisitorConsent();
    const withdrawing = purposes.some(p => previous[p] === 'yes' && !choices[p]);
    setBusy(true);
    showError(false);
    clearTimeout(consentTimer);
    let finished = false, checkTimer;
    const finish = current => {
      if (finished) return;
      finished = true;
      clearTimeout(timeout);
      clearTimeout(checkTimer);
      const effectiveChoices = {...choices, sale_of_data: current.sale_of_data === 'yes' && choices.sale_of_data};
      try {
        document.cookie = `cz_privacy_choice=${encodeURIComponent(JSON.stringify({version,at:Date.now(),choices:effectiveChoices,id:api.consentId?.() || null}))}; Max-Age=${maxAge}; Path=/; SameSite=Lax; Secure`;
      } catch {}
      dismissed = false;
      try { document.cookie = `${dismissalKey}=; Max-Age=0; Path=/; SameSite=Lax; Secure`; } catch {}
      syncGoogle(current);
      setBanner(false);
      if (dialog.open) close(dialog);
      setBusy(false);
      if (withdrawing) location.reload();
    };
    const fail = () => {
      if (finished) return;
      finished = true;
      clearTimeout(timeout);
      clearTimeout(checkTimer);
      setBusy(false);
      showError(true);
    };
    const check = () => {
      if (finished) return;
      try {
        const current = api.currentVisitorConsent();
        if (matchesChoices(current, choices)) {finish(current);return;}
      } catch {}
      checkTimer = setTimeout(check, 100);
    };
    const timeout = setTimeout(fail, 10000);
    try {
      api.setTrackingConsent(choices, result => {
        if (finished) return;
        if (result?.error) {fail();return;}
        clearTimeout(checkTimer);
        check();
      });
    } catch {fail();}
  };
  const loadApi = () => {
    clearTimeout(retryTimer);
    if (window.Shopify?.customerPrivacy) {api = window.Shopify.customerPrivacy; sync(); return;}
    if (!window.Shopify?.loadFeatures) {if (++attempts < 30) retryTimer = setTimeout(loadApi, 500); else {setBanner(!dismissed);showError(true);}return;}
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
      if (error || !window.Shopify.customerPrivacy) {setBanner(!dismissed); showError(true);return;}
      api = window.Shopify.customerPrivacy;
      sync();
    });
  };
  document.addEventListener('click', e => {
    if (e.target.closest('[data-cz-dismiss-error]')) {
      dismissed = true;
      try { document.cookie = `${dismissalKey}=${Date.now() + 86400000}; Max-Age=86400; Path=/; SameSite=Lax; Secure`; } catch {}
      syncGoogle(Object.fromEntries(purposes.map(p => [p, 'no'])));
      setBanner(false);
      if (dialog.open) close(dialog);
      return;
    }
    const action = e.target.closest('[data-cz-consent]');
    if (action) save(action.dataset.czConsent);
    if (e.target.closest('[data-cz-cookie-settings]')) openSettings();
    if (e.target.closest('[data-cz-guarantee]')) {lastFocus = document.activeElement;if (!guarantee.open) guarantee.showModal();}
    const closing = e.target.closest('[data-cz-dialog-close]');
    if (closing) close(closing.closest('dialog'));
  });
  [dialog, guarantee].forEach(d => d.addEventListener('cancel', () => {if (lastFocus?.isConnected) lastFocus.focus({preventScroll:true});}));
  window.addEventListener('pageshow', () => {if (api) sync();});
  document.addEventListener('visitorConsentCollected', () => {if (api) sync();});
  setBanner(false);
  loadApi();
})();

